<template>
  <b-badge
    v-if="activity && activity.value"
    :title="inferred ? $t('serviceTypes.gl.inferred_tooltip') : (activity.description_ar || activity.label_ar)"
    :class="['gl-activity-chip', `gl-activity-chip--${activity.value}`, { 'gl-activity-chip--inferred': inferred }]"
  >
    {{ activity.label_ar || activity.value }}
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'GlActivityChip',
  components: { BBadge },
  props: {
    activity: { type: Object, default: null },
    inferred: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.gl-activity-chip {
  font-weight: 600;
  color: #fff;
}
.gl-activity-chip--survey { background: #1e6bd6; }
.gl-activity-chip--contracting { background: #e67e22; }
.gl-activity-chip--licensing { background: #7c3aed; }
.gl-activity-chip--maps { background: #28a745; }
.gl-activity-chip--inferred {
  background: transparent;
  border: 1px solid currentColor;
}
.gl-activity-chip--inferred.gl-activity-chip--survey { color: #1e6bd6; }
.gl-activity-chip--inferred.gl-activity-chip--contracting { color: #e67e22; }
.gl-activity-chip--inferred.gl-activity-chip--licensing { color: #7c3aed; }
.gl-activity-chip--inferred.gl-activity-chip--maps { color: #28a745; }
</style>
